import {} from '@fortawesome/free-brands-svg-icons'
import {} from '@fortawesome/free-regular-svg-icons'
import {
  faBars,
  faCaretDown,
  faHome,
  faDatabase,
  faFileAlt,
  faPoll,
  faClipboardList,
  faFlag,
  faColumns,
  faCogs,
  faUsers,
  faTasks,
  faUserTie,
  faServer,
  faPlusSquare,
  faTimes,
  faTrashAlt,
  faEdit,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faUser,
  faSearch,
  faEllipsisV,
  faCopy,
  faChartArea,
  faComment,
  faCalculator,
  faTachometerAlt,
  faChartLine,
  faFileInvoice
} from '@fortawesome/free-solid-svg-icons'

const icons = {
  faBars,
  faCaretDown,
  faHome,
  faDatabase,
  faFileAlt,
  faPoll,
  faClipboardList,
  faFlag,
  faColumns,
  faCogs,
  faUsers,
  faTasks,
  faUserTie,
  faServer,
  faPlusSquare,
  faTimes,
  faTrashAlt,
  faEdit,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faUser,
  faSearch,
  faEllipsisV,
  faCopy,
  faChartArea,
  faComment,
  faCalculator,
  faTachometerAlt,
  faChartLine,
  faFileInvoice
}

export default {
  ...icons
}
